var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSprievodnaDokumentacia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_39705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.44667 2.25H3.33333C2.6 2.25 2 2.85 2 3.58333V12.9167C2 13.65 2.6 14.25 3.33333 14.25H12.6667C13.4 14.25 14 13.65 14 12.9167V6.80333C14 6.45 13.86 6.11 13.6067 5.86333L10.3867 2.64333C10.14 2.39 9.8 2.25 9.44667 2.25ZM5.33333 10.25H10.6667C11.0333 10.25 11.3333 10.55 11.3333 10.9167C11.3333 11.2833 11.0333 11.5833 10.6667 11.5833H5.33333C4.96667 11.5833 4.66667 11.2833 4.66667 10.9167C4.66667 10.55 4.96667 10.25 5.33333 10.25ZM5.33333 7.58333H10.6667C11.0333 7.58333 11.3333 7.88333 11.3333 8.25C11.3333 8.61667 11.0333 8.91667 10.6667 8.91667H5.33333C4.96667 8.91667 4.66667 8.61667 4.66667 8.25C4.66667 7.88333 4.96667 7.58333 5.33333 7.58333ZM5.33333 4.91667H8.66667C9.03333 4.91667 9.33333 5.21667 9.33333 5.58333C9.33333 5.95 9.03333 6.25 8.66667 6.25H5.33333C4.96667 6.25 4.66667 5.95 4.66667 5.58333C4.66667 5.21667 4.96667 4.91667 5.33333 4.91667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_39705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprievodnaDokumentacia);
export default __webpack_public_path__ + "static/media/icon-sprievodna-dokumentacia.3d4dc7a3dd8878c62cbce1d26b9c505f.svg";
export { ForwardRef as ReactComponent };